import { FunctionalComponent, h } from 'preact';

import { CountryCodeEnum } from 'common/data/country/code.enum';
import { configGetCountry } from 'common/helper/config/get-country';
import { i18nTranslate } from 'common/helper/i18n/translate';
import { IconVerifiedBadge } from 'common/module/icon/verified-badge';
import { preactLifecycleComponent } from 'common/module/preact/lifecycle-component';
import { ProgressiveImageComponent } from 'common/module/progressive-image/component';
import { BrokerCardTemplatePropsInterface } from 'desktop/module/broker/card/template-props.interface';

// TODO-FE[WEB-1602]: Refactor this to work with common BrokerCardTemplatePropsInterface
const Markup: FunctionalComponent<BrokerCardTemplatePropsInterface> = (props): preact.JSX.Element => (
  <div className='tile' onClick={(e: Event) => props.onClickBroker(e, props.broker)}>
    <div className='tile__images'>
      <ProgressiveImageComponent
        src={props.broker.public_logo_large}
        classname='tile__cover'
        loadedClass='tile__cover--loaded'
        alt={props.broker.name}
        placeholder={__('assets/common/broker-tile-placeholder.jpg')}
        preloader={__('assets/common/image-loader.svg')}
      />
    </div>
    <div className='tile__content'>
      <div className='tile__main-info tile__main-info--size1'>
        <div className='tile__title'>
          <span className='tile__title-text'>{props.broker.name}</span>
          {configGetCountry().code === CountryCodeEnum.qa && props.broker.is_verified && (
            <div className='tile__title-verified-info'>
              <IconVerifiedBadge class='tile__title-verified-icon' />
              <div className='tooltip2 tooltip2--top'>
                <div className='tooltip2__content'>
                  <span>{i18nTranslate('broker:verified:info')}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {(configGetCountry().agentSection.agentsEnabled || configGetCountry().agentSection.displayHeadOffice) && (
        <div className='tile__details'>
          {configGetCountry().agentSection.agentsEnabled && (
            <div className='tile__detail-row tile__detail-row--centered'>
              <div className='tile__detail'>
                {props.broker.agents} {i18nTranslate('Agents')}
              </div>
            </div>
          )}
          {configGetCountry().agentSection.displayHeadOffice && (
            <div className='tile__detail-row tile__detail-row--centered tile__detail-row--stacked tile__detail-row--padded'>
              <div className='tile__detail-name'>{i18nTranslate('Head Office')}</div>
              <div className='tile__detail-value'>{props.broker.location_name}</div>
            </div>
          )}
        </div>
      )}
      <div className='tile__counters'>
        <div className='counter tile__counter'>
          <div className='counter__count'>{props.broker.properties_residential_for_rent_count}</div>
          <div className='counter__label'>{i18nTranslate('for rent')}</div>
        </div>
        <div className='counter tile__counter'>
          <div className='counter__count'>{props.broker.properties_residential_for_sale_count}</div>
          <div className='counter__label'>{i18nTranslate('for sale')}</div>
        </div>
        <div className='counter tile__counter'>
          <div className='counter__count'>{props.broker.properties_commercial_count}</div>
          <div className='counter__label'>{i18nTranslate('Commercial')}</div>
        </div>
      </div>
    </div>
  </div>
);

export const BrokerCardTemplate = preactLifecycleComponent(Markup);
